






import Vue from 'vue';
import Highcharts from 'highcharts';
import boost from 'highcharts/modules/boost';
import { Chart } from 'highcharts-vue';

boost(Highcharts);

export default Vue.extend({
  name: 'TextReadabilityChart',
  components: {
    Chart,
  },
  props: {
    options: Object,
  },
  computed: {
    chartOptions: {
      get(): Highcharts.Options {
        return Highcharts.merge(this.options, {
          chart: {
            zoomType: 'x',
            panKey: 'meta',
            panning: true,
          },
          title: {
            text: 'Readability by paragraph',
          },
          xAxis: {
            title: {
              text: 'Paragraph',
            },
          },
          yAxis: {
            title: {
              text: 'Readability',
            },
          },
          tooltip: {
            split: true,
          },
          plotOptions: {
            series: {
              allowPointSelect: true,
              point: {
                events: {
                  select: this.getPointSelectedCallback(),
                },
              },
            },
          },
        } as Highcharts.Options);
      },
    },
  },
  watch: {
    options: {
      handler(newOptions) {
        this.chartOptions.series = newOptions.series;
      },
      deep: true,
    },
  },
  methods: {
    pointSelected(n: number): void {
      this.$emit('point-selected', n);
    },
    getPointSelectedCallback(): Highcharts.PointSelectCallbackFunction {
      const emitter = this.pointSelected.bind(this);
      return ((function callback(): void {
        emitter(this.x);
      }) as Highcharts.PointSelectCallbackFunction);
    },
  },
});
